var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "40DE2B38-6D4D-4A85-AF5F-4B6B19D8CB03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D---Dashboard_Menu_collapsed-Copy",
    transform: "translate(-24.000000, -1040.000000)",
    stroke: "#C6D7EA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout-1-copy",
    transform: "translate(25.000000, 1041.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.3125,
    y1: 7.7945,
    x2: 16.46875,
    y2: 7.7945,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "13.8125 10.45075 16.46875 7.7945 13.8125 5.13825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.15625,10.9791667 L11.15625,14.1666667 C11.1815084,14.7263835 10.7496751,15.2012736 10.1900833,15.2291667 L1.49670833,15.2291667 C0.937398009,15.2008978 0.505983857,14.7261207 0.53125,14.1666667 L0.53125,1.41666667 C0.505588883,0.857070245 0.937218534,0.382055956 1.49670833,0.354166667 L10.1900833,0.354166667 C10.7496751,0.382059743 11.1815084,0.856949839 11.15625,1.41666667 L11.15625,4.60416667",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.dd5dd4b658d734eef2fa3dec5977c430.svg";
export { ForwardRef as ReactComponent };